import type { ReactElement } from "react";
import Prezentare from "./pagini/Prezentare";
import Setari from "./pagini/Setari";

// Cheile trebuie sa corespunda exact id-urilor paginilor GRUP_CONFIGURARE din
// src/config/administrare.ts (verificat de un test — vezi rutePagini.test.ts).
export const PAGINI_CONFIGURARE: Record<string, ReactElement> = {
  prezentare: <Prezentare />,
  setari: <Setari />,
};
